import { notification } from 'antd';

const Notify = ({ msg, text, type = 'success' }) => {
  notification[type]({
    message: msg,
    description: text,
    placement: 'topLeft',
    className: `${type}-alertbox-test`,
  });
};

export const notifyError = (title, description) => {
  notification.error({
    message: title,
    description: description,
    placement: 'topLeft',
  });
};

export const notifySuccess = (title, description) => {
  notification.success({
    message: title,
    description: description,
    placement: 'topLeft',
  });
};

export const notifyWarning = (title, description) => {
  notification.warning({
    message: title,
    description: description,
    placement: 'topLeft',
  });
};

Notify.error = notifyError;
Notify.success = notifySuccess;
Notify.warning = notifyWarning;

export { Notify };
